import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boxLogs'
})
export class BoxLogsPipe implements PipeTransform {


  transform(value: string): string {
    let splitted = value.split("/");
    if (splitted.length > 0)
      value = splitted[splitted.length - 1];
    splitted = value.split(".");
    if (splitted.length > 0)
      value = splitted[0];

    return value;

  }

}
